import { render, staticRenderFns } from "./orderEntry.vue?vue&type=template&id=71b96bde&scoped=true"
import script from "./orderEntry.vue?vue&type=script&lang=js"
export * from "./orderEntry.vue?vue&type=script&lang=js"
import style0 from "./orderEntry.vue?vue&type=style&index=0&id=71b96bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b96bde",
  null
  
)

export default component.exports